import script from "./SupportView.vue?vue&type=script&setup=true&lang=ts"
export * from "./SupportView.vue?vue&type=script&setup=true&lang=ts"

import "./SupportView.vue?vue&type=style&index=0&id=87919412&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-87919412"]])

export default __exports__